export default "__VITE_ASSET__BxD4jsCg__"